import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import toast from 'react-hot-toast';

import { errorHelper } from 'src/utils';
import http from 'src/api/endpoints';
import { ErrorMessageFromApi } from 'src/constants';
import { PARENT_URL } from 'src/config/parentURL';

interface IFilterData {
  statuses: {
    Project: [];
    Staffing: [];
  };
  filterRoles: [];
}

interface InitialState {
  loading: boolean;
  data: IFilterData;
  error: string | undefined | null;
}

const initialFilterData: IFilterData = {
  statuses: {
    Project: [],
    Staffing: [],
  },
  filterRoles: [],
};

const initialState: InitialState = {
  loading: false,
  data: initialFilterData,
  error: null,
};

export const getAllFilters = createAsyncThunk('filters', async (_, thunk) => {
  try {
    const response = await http.getAllFilters(PARENT_URL.META_DATA);
    if (response.message === 'The request is completed successfully') {
      return response.data;
    }
    return thunk.rejectWithValue(errorHelper(ErrorMessageFromApi));
  } catch (error) {
    return thunk.rejectWithValue(errorHelper(error));
  }
});

export const filtersSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getAllFilters.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllFilters.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getAllFilters.rejected, (state, action) => {
        state.loading = false;
        state.data = initialFilterData;
        state.error = action.error.message;
        toast.error(ErrorMessageFromApi, { duration: 2000 });
      });
  },
});
